export default __webpack_public_path__ + "static/media/carzone.54adb54a.png";